module.exports = __webpack_public_path__ + "img/cooperate_jr_06@2x.37201bb6.png";